export const siteName = "Job Entry";
export const baseUrl = "https://saas.adnan-tech.com";
// export const baseUrl = "http://localhost:8000";
export const accessTokenKey = "JobEntry_Access_987654321";
export const googleClientID = "652468111151-1ormq229gmhp8ltdmj7r90i4jccvabv3.apps.googleusercontent.com";
export const contact = {
    phone: "+923105461304",
    email: "support@adnan-tech.com",
    address: "Lahore, Pakistan"
};
export const price = 99;
export const isPremium = true;
export const premiumMessage = "This feature is available in premium version only.";
export const globalState = {
    state: {
        user: null,
        settings: null,
        chats: [],
        newMessages: 0,
        totalNotifications: 0
    },

    listeners: [],

    listen (callBack) {
        this.listeners.push(callBack);
    },

    setState (newState) {
        this.state = {
            ...this.state,
            ...newState
        };

        for (let a = 0; a < this.listeners.length; a++) {
            this.listeners[a](this.state, newState);
        }
    }
};

export function prettyPrintJson(data, indent = 0) {
    const spacing = '    '.repeat(indent); // 4 spaces per indent level

    if (Array.isArray(data)) {
        let output = '[\n';
        const items = data.map(value => {
            const line = spacing + '    ' + (
                typeof value === 'object' && value !== null
                    ? prettyPrintJson(value, indent + 1)
                    : (typeof value === 'string' ? `"${value}"` : value)
            );
            return line;
        });
        output += items.join(',\n');
        output += `\n${spacing}]`;
        return output;
    } else if (typeof data === 'object' && data !== null) {
        let output = '{\n';
        const items = Object.keys(data).map(key => {
            const value = data[key];
            const line = spacing + '    "' + key + '": ' + (
                typeof value === 'object' && value !== null
                    ? prettyPrintJson(value, indent + 1)
                    : (typeof value === 'string' ? `"${value}"` : value)
            );
            return line;
        });
        output += items.join(',\n');
        output += `\n${spacing}}`;
        return output;
    } else {
        return JSON.stringify(data);
    }
}

export function addOrUpdateURLParam (key, value) {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set(key, value)
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString()
    window.history.pushState(null, "", newRelativePathQuery)
}

export function normalizeExternalUrl(href) {
  if (/^(https?:)?\/\//i.test(href)) {
    return href; // already absolute
  }
  return "https://" + href;
}
